import React from "react";
import { Link } from "react-router-dom";

export function Services() {
  const serviceOfferings = [
    {
      icon: "☁️",
      title: "Cloud Infrastructure & DevOps",
      desc: "Architecting scalable, resilient, and secure multi-cloud environments across AWS, Azure, and Google Cloud. Implementing continuous integration, automated deployment pipelines (CI/CD), and Infrastructure as Code (IaC).",
      features: ["AWS / Azure / GCP Architecture", "Kubernetes & Docker Containerization", "Terraform & CloudFormation", "Cost Optimization & 24/7 Monitoring"]
    },
    {
      icon: "💻",
      title: "Custom Web & Mobile Development",
      desc: "Building mission-critical, high-performance web and mobile applications tailored to complex business workflows. From robust backend microservices to intuitive user experiences.",
      features: ["React, Node.js, Python, Java", "Native & Cross-Platform Mobile Apps", "Enterprise API & Microservices Design", "Secure Database Architectures"]
    },
    {
      icon: "⚡",
      title: "Intelligent Automation & RPA",
      desc: "Streamlining repetitive enterprise processes and eliminating manual bottlenecks through automated workflows, AI integrations, and end-to-end robotic process automation.",
      features: ["Workflow Process Automation", "API Integrations & ETL Pipelines", "Automated QA & Regression Testing", "Data Transformation & Reporting"]
    },
    {
      icon: "👥",
      title: "IT Consulting & Strategic Staffing",
      desc: "Empowering your internal teams with senior technology consultants, specialized engineering squads, and flexible human capital solutions aligned with your strategic roadmaps.",
      features: ["Dedicated Engineering Pods", "Technical Architecture Advisory", "Contract-to-Hire & Direct Placement", "Project-Based Technical Leadership"]
    },
    {
      icon: "🔒",
      title: "Cybersecurity & Cloud Governance",
      desc: "Fortifying your digital footprint with modern security standards, access control audits, zero-trust patterns, and regulatory compliance protocols.",
      features: ["IAM & Access Management Audits", "Vulnerability Assessment", "Data Encryption & Compliance", "SSL/TLS & Network Hardening"]
    },
    {
      icon: "📊",
      title: "Data Engineering & Analytics",
      desc: "Transforming fragmented business data into actionable real-time intelligence with scalable pipelines, data warehouses, and modern analytics dashboards.",
      features: ["Data Pipeline Engineering", "Cloud Data Warehouses (Snowflake, BigQuery)", "Business Intelligence Dashboards", "Predictive Analytics Support"]
    }
  ];

  const methodology = [
    {
      step: "01",
      title: "Discovery & Assessment",
      desc: "We analyze your business objectives, current architecture, workflows, and pain points to define precise technical requirements."
    },
    {
      step: "02",
      title: "Solution Architecture",
      desc: "Our senior architects design a resilient, future-proof blueprint focused on performance, cost efficiency, and security."
    },
    {
      step: "03",
      title: "Agile Engineering",
      desc: "Iterative sprints with transparent milestones, regular demos, automated testing, and clean maintainable code standards."
    },
    {
      step: "04",
      title: "Deployment & Support",
      desc: "Seamless rollout with zero downtime, robust monitoring, knowledge transfer, and dedicated ongoing maintenance."
    }
  ];

  return (
    <div className="services-page">
      <div className="page-banner">
        <div className="container">
          <span className="badge">Our Capabilities</span>
          <h1>Comprehensive IT Consulting Services</h1>
          <p>
            End-to-end technology solutions engineered to drive efficiency, agility, and measurable business growth.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">What We Deliver</span>
            <h2 className="section-title">Tailored Enterprise Solutions</h2>
            <p className="section-desc">
              Whether you need to modernize legacy systems, automate complex business processes, or scale your engineering capabilities, ACT is your trusted partner.
            </p>
          </div>

          <div className="cards-grid">
            {serviceOfferings.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon-box">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-text">{service.desc}</p>
                <div className="service-tags">
                  {service.features.map((feat, idx) => (
                    <span key={idx} className="pill">{feat}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Methodology */}
      <section className="section" style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e2e8f0" }}>
        <div className="container">
          <div className="section-header">
            <span className="section-tag">How We Work</span>
            <h2 className="section-title">Our Proven Delivery Framework</h2>
            <p className="section-desc">
              We combine agile methodology with enterprise rigor to deliver projects on time, within budget, and to the highest quality standards.
            </p>
          </div>

          <div className="timeline">
            {methodology.map((m, idx) => (
              <div key={idx} className="timeline-step">
                <span className="step-number">{m.step}</span>
                <h3 className="step-title">{m.title}</h3>
                <p className="step-desc">{m.desc}</p>
              </div>
            ))}
          </div>

          <div className="cta-banner">
            <h2>Ready to discuss your technology goals?</h2>
            <p>
              Connect with our consulting team for a free technical assessment and roadmap.
            </p>
            <Link to="/contact" className="btn-white">
              Get in Touch Today →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
